export const getPaginatedItems = (response) => {
  if (Array.isArray(response)) return response
  if (Array.isArray(response?.data)) return response.data
  if (Array.isArray(response?.value)) return response.value
  return []
}

export const getApiErrorMessage = (error, fallback = 'No se han podido cargar los datos') => (
  Array.isArray(error?.response?.data?.details) && error.response.data.details.length > 0
    ? error.response.data.details.join('\n')
    : error?.response?.data?.message || fallback
)

export const formatDateTime = (value, fallback = 'Sin actividad') => {
  if (!value) return fallback

  try {
    return new Intl.DateTimeFormat('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(value))
  } catch {
    return String(value)
  }
}
